<script lang="ts">
	import type { IListingPageTemplateWithoutImage } from '$lib/utils/contentful/types';
	import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
  import HeroPath from './HeroPath.svelte';

  export let listingPageTemplate: IListingPageTemplateWithoutImage;

  const bgColor: string = listingPageTemplate.fields.heroBackgroundColor || '';
  const textColor: string = listingPageTemplate.fields.heroTextColor ? (listingPageTemplate.fields.heroTextColor.toLowerCase() === 'bianco' ? '#ffffff' : '#090909') : '#ffffff';
</script>

<HeroPath
  type={listingPageTemplate.fields.heroTitle}
  title={listingPageTemplate.fields.heroTitle}
  style={
    `${bgColor ? `--tint-color: ${bgColor};` : ''}${textColor ? ` --tint-contrast-color: ${textColor};` : ''}`
  }
>
  <span slot="type">{listingPageTemplate.fields.heroBadgeLabel}</span>
  <span slot="title">{listingPageTemplate.fields.heroTitle}</span>
  {@html documentToHtmlString(listingPageTemplate.fields.heroDescription)}
</HeroPath>


